module.exports = __webpack_public_path__ + "static/media/ic_vehicle_idle.fefd7ae7.png";